// src/modules/Courier/pages/CourierModal/pages/FailurePage.jsx
import React, { useState, useRef } from 'react';
import { useRouteStore } from '../../Route/useRouteStore';
import api from '../../../../services/api';
import styles from '../styles/FailurePage.module.css';

export default function FailurePage() {
  const receiptId     = useRouteStore(s => s.selectedReceiptId);
  //для того чтобы знать пробит ли чек
  const receipt      = useRouteStore(s => s.selectedReceipt);
  //
  const updateReceipt = useRouteStore(s => s.updateReceipt);
  const closeModal    = () => useRouteStore.getState().setModalPage(null);

  const reasons = [
    {
      key: 'client',
      category: 'Клиент',
      options: [
        { label: 'Не открыл дверь' },
        { label: 'Не отвечает на звонки' },
        { label: 'Отказался от заказа' },
        { label: 'Отсутствует по адресу' }
      ]
    },
    {
      key: 'invalidOrder',
      category: 'Ошибка в заказе',
      options: [
        { label: 'Неверный адрес' },
        { label: 'Клиент не делал заказ' },
        { label: 'Уже было доставлено' }
      ]
    },
    {
      key: 'reschedule',
      category: 'Перенос доставки',
      options: [
        { label: 'Клиент перенёс на другой день' },
        { label: 'Заказан на другую дату' },
        { label: 'Не готов принять сегодня' }
      ]
    },
    {
      key: 'timeLimit',
      category: 'Не успели по времени',
      options: [
        { label: 'Работают до...', withTime: true },
        { label: 'Не берет из-за опоздания' }
      ]
    },
    {
      key: 'technical',
      category: 'Технические причины',
      options: [
        { label: 'Повреждение товара в пути' },
        { label: 'Поломка автомобиля' },
        { label: 'ДТП' }
      ]
    }
  ];

  const [step, setStep]           = useState('categories'); // categories | options | manual
  const [selectedGroup, setGroup] = useState(null);
  const [manualReason, setManual] = useState('');
  const pendingOption             = useRef(null);
  const timeInputRef              = useRef();

  // --- API call + close ---
const applyReason = async reason => {
  try {
    // 1) Ставим статус «Не доставлено» с причиной
    const resStatus = await api.patch(
      `/receipts/${receiptId}/status`,
      { status: 'Не доставлено', reason }
    );
    const updatedStatus = resStatus.data ?? resStatus;
    updateReceipt(updatedStatus);

    // 2) Если чек уже был пробит — отправляем запрос на refund без await
    if (receipt?.is_check_issued) {
      api
        .post(`/check/${receiptId}/refund`)
        .catch(err => {
          console.error('Не удалось вернуть чек:', err);
        });
    }

    // 3) Закрываем модалку
    closeModal();
  } catch (e) {
    console.error('Ошибка при сохранении причины:', e);
    alert('Не удалось сохранить причину. Попробуйте ещё раз.');
  }
};

  const pickCategory = group => {
    setGroup(group);
    setStep('options');
  };

  const confirmOption = opt => {
    if (opt.withTime) {
      pendingOption.current = opt;
      timeInputRef.current?.showPicker?.() || timeInputRef.current.click();
    } else {
      applyReason(`${selectedGroup.category}: ${opt.label}`);
    }
  };

  const onTimeChange = e => {
    const t = e.target.value;
    const label = pendingOption.current.label.replace('...', t);
    applyReason(`${selectedGroup.category}: ${label}`);
  };

  const startManual = () => {
    setManual('');
    setStep('manual');
  };

  const confirmManual = () => {
    const txt = manualReason.trim();
    if (txt) applyReason(txt);
  };

  const backToCategories = () => {
    setStep('categories');
    setGroup(null);
  };

  return (
    <div className={styles.container}>

    <div>
      {step === 'categories' && (
        <>
          <div className={styles.grid}>
            {reasons.map(g => (
              <button
                key={g.key}
                className={`${styles.categoryBtn} ${styles[g.key]}`}
                onClick={() => pickCategory(g)}
              >
                {g.category}
              </button>
            ))}
            <button
              className={styles.manualBtn}
              onClick={startManual}
            >
              Другая причина…
            </button>
          </div>
          <button
            className={styles.cancelBtn}
            onClick={closeModal}
          >
            Отмена
          </button>
        </>
      )}

      {step === 'options' && selectedGroup && (
        <>
          <h3 className={styles.title}>{selectedGroup.category}</h3>
          <div className={styles.list}>
            {selectedGroup.options.map((opt, idx) => (
              <button
                key={idx}
                className={styles.optionBtn}
                onClick={() => confirmOption(opt)}
              >
                {opt.label}
              </button>
            ))}
          </div>
          <input
            type="time"
            ref={timeInputRef}
            className={styles.hiddenTime}
            onChange={onTimeChange}
          />
          <div className={styles.footer}>
            <button
              className={styles.backBtn}
              onClick={backToCategories}
            >
              Назад
            </button>
            <button
              className={styles.cancelBtn}
              onClick={closeModal}
            >
              Отмена
            </button>
          </div>
        </>
      )}

      {step === 'manual' && (
        <>
          <h3 className={styles.title}>Укажите причину вручную</h3>
          <textarea
            className={styles.textarea}
            placeholder="Введите причину…"
            value={manualReason}
            onChange={e => setManual(e.target.value)}
          />
          <div className={styles.footer}>
            <button
              className={styles.backBtn}
              onClick={backToCategories}
            >
              Назад
            </button>
            <button
              className={styles.confirmBtn}
              disabled={!manualReason.trim()}
              onClick={confirmManual}
            >
              Подтвердить
            </button>
          </div>
        </>
      )}
    </div>
    </div>
  );
}
